// 10% of penal amount on bonds $200 to $3,000   Minimum - $10 on bonds less than $200
// For bonds over $3,000 in penal amount:
// 10% on first $3,000 of penal amount; then
//  8% on penal amount of $3,001 to $10,000; then
//  6% on penal amount over $10,000

/* eslint-disable */
export const equation = ({ bondValue, type }) => {
  let value = null
  let condition = null
  let minimum = 10
  
  if (type === 'STATE') {
    if (bondValue < 200) {
      value = 10
      condition = 'Minimum not met'
    } else {
      value = (bondValue * .1)
      if (bondValue > 3000 && bondValue <= 10000) {
        value += (bondValue * .08)
        if (bondValue > 10000) {
          value += (bondValue * .06)
        }
      }
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation